import { GetterTree } from "vuex";
import { RootState, CourseState } from "@/interface";
import { isCourseDetailLoadedGetter, courseDetailGetter } from "./getter-types";

export const getters: GetterTree<CourseState, RootState> = {
  [isCourseDetailLoadedGetter]: (state: CourseState) => (courseId: string) => {
    return Boolean(state.courseMap && state.courseMap[courseId]);
  },
  [courseDetailGetter]: (state: CourseState) => (courseId: string) => {
    return state.courseMap && state.courseMap[courseId];
  }
};
